// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__UhZSE","Header__h1":"Header_Header__h1__9EoKg","Header__p":"Header_Header__p__M1+EN"};